import { AuthorizedLayout, ProgressLoaders } from 'components'
import { Box } from '@mui/material'
import { ROUTES_PATH } from 'config'
import { SignupConfirm, SignupSuccess } from 'containers/Auth'
import { SignInAsCustomer } from 'containers/Auth/SignInAsCustomer'
import { Account } from 'pages/account'
import { AccountPreferences } from 'pages/accountPreferences'
import { ForgotPassword, ForgotPasswordReset, SignIn, SignUp } from 'pages/auth'
import { Billing } from 'pages/billing'
import { Dashboard } from 'pages/dashboard'
import { FAQs, AuthorizedFaqs } from 'pages/faqs'
import { Pay } from 'pages/pay'
import { AuthorizedServices, Services } from 'pages/services'
// import { ResidentResources } from 'pages/resources'
import { SystemUnderMaintenance } from 'pages/systemUnderMaintenance'
import { Usage } from 'pages/usage'
import { AuthorizedRoute } from './AuthorizedRoute'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider
} from 'react-router-dom'
import { useMaintenance } from '../context/maintenance'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path={ROUTES_PATH.SIGNIN} element={<SignIn />} />
      <Route
        path={ROUTES_PATH.SIGN_IN_AS_CUSTOMER}
        element={<SignInAsCustomer />}
      />
      <Route path={ROUTES_PATH.SIGNUP} element={<SignUp />} />
      <Route path={ROUTES_PATH.SIGNUP_CONFIRM} element={<SignupConfirm />} />
      <Route path={ROUTES_PATH.SIGNUP_SUCCESS} element={<SignupSuccess />} />
      <Route path={ROUTES_PATH.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route
        path={ROUTES_PATH.FORGOT_PASSWORD_RESET}
        element={<ForgotPasswordReset />}
      />
      <Route path={ROUTES_PATH.PAY} element={<Pay />} />
      <Route path={ROUTES_PATH.SERVICES} element={<Services />} />
      <Route path={ROUTES_PATH.FAQS} element={<FAQs />} />
      <Route path={ROUTES_PATH.DASHBOARD} element={<AuthorizedLayout />}>
        <Route
          index
          element={
            <AuthorizedRoute>
              <Dashboard />
            </AuthorizedRoute>
          }
        />
        <Route
          path='*'
          element={<Navigate to={ROUTES_PATH.DASHBOARD} replace />}
        />
        <Route
          path={ROUTES_PATH.ACCOUNT}
          element={
            <AuthorizedRoute>
              <Account />
            </AuthorizedRoute>
          }
        />
        <Route
          path={ROUTES_PATH.USAGE}
          element={
            <AuthorizedRoute>
              <Usage />
            </AuthorizedRoute>
          }
        />
        <Route
          path={ROUTES_PATH.BILLING}
          element={
            <AuthorizedRoute>
              <Billing />
            </AuthorizedRoute>
          }
        />
        <Route
          path={ROUTES_PATH.AUTHORIZED_SERVICES}
          element={
            <AuthorizedRoute>
              <AuthorizedServices />
            </AuthorizedRoute>
          }
        />
        {/* <Route
                path={ROUTES_PATH.RESIDENT_RESOURCES}
                element={
                  <AuthorizedRoute>
                    <ResidentResources />
                  </AuthorizedRoute>
                }
              /> */}
        <Route
          path={ROUTES_PATH.SETTINGS}
          element={
            <AuthorizedRoute>
              <AccountPreferences />
            </AuthorizedRoute>
          }
        />
        <Route
          path={ROUTES_PATH.AUTHORIZEDFAQS}
          element={
            <AuthorizedRoute>
              <AuthorizedFaqs />
            </AuthorizedRoute>
          }
        />
      </Route>
      <Route
        path='*'
        element={
          <AuthorizedRoute>
            <AuthorizedLayout />
          </AuthorizedRoute>
        }
      ></Route>
    </Route>
  )
)

export const AppRoutes = (): JSX.Element => {
  const { isMaintenance } = useMaintenance()

  if (isMaintenance === null) {
    return (
      <Box>
        <ProgressLoaders height="100vh" />
      </Box>
    )
  }

  if (isMaintenance) {
    return <SystemUnderMaintenance />
  }

  return <RouterProvider router={router} />
}
